'use client'

import { useState, useEffect } from "react"
import { ScrollingAnnouncementBar } from "@/components/dashboard/scrolling-announcement-bar"
import { GameInfoSection } from "@/components/dashboard/game-info-section"
import { NavigationMenu } from "@/components/dashboard/navigation-menu"
import { cn } from "@/lib/utils"
import { GenericTablePageContent } from "@/components/dashboard/generic-table-page-content"
import { renderReportRowCells } from "@/components/dashboard/table-row-renderers"
import { fetchReportData } from "@/lib/api"

export default function ChoiceWinningReportPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [selectedGame, setSelectedGame] = useState("Choice")
  const [tableData, setTableData] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  const username = "defaultUser"
  const userRole: "user" | "admin" = "admin"

  const tableHeaders = [
    { label: "Sr. No.", sortable: true },
    { label: "Date", sortable: true },
    { label: "Session", sortable: true },
    { label: "User ID", sortable: true },
    { label: "Name", sortable: true },
    { label: "Numbers", sortable: true },
    { label: "Qty.", sortable: true },
    { label: "Amount", sortable: true },
    { label: "Status", sortable: true },
  ]

  useEffect(() => {
    const loadData = async () => {
      setLoading(true)
      try {
        const data = await fetchReportData('choice')
        const formattedData = data.map((item: any, index: number) => ({
          id: item.id,
          srNo: index + 1,
          date: new Date(item.createdAt).toLocaleDateString(),
          session: item.session.name,
          userId: item.user.userId,
          userName: item.user.name || 'N/A',
          numbers: item.numbers,
          qty: item.qty,
          amount: item.amount,
          status: item.status,
          rawData: item
        }))
        setTableData(formattedData)
      } catch (error) {
        console.error("Error loading choice report data:", error)
      } finally {
        setLoading(false)
      }
    }

    loadData()
  }, [])

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <header className="bg-gradient-to-r from-red-800 to-red-900 text-white py-3 px-4 sm:px-6 flex items-center justify-between shadow-md">
        <div className="flex items-center gap-4">
          <span className={cn("text-lg font-semibold", isMobileMenuOpen && "hidden sm:block")}>
            Three Circle 7 - Welcome: {username}
          </span>
        </div>
        <NavigationMenu isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
      </header>

      <ScrollingAnnouncementBar text="🎯 Welcome to Three Circle 7 Lottery • Latest Results Available • Play Responsibly • Good Luck! • 🎯 Welcome to Three Circle 7 Lottery • Latest Results Available • Play Responsibly • Good Luck! •" />

      <main className="flex-1 p-3 sm:p-4">
        <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg p-4">
          <GameInfoSection selectedGame={selectedGame} onGameChange={setSelectedGame} />

          <GenericTablePageContent
            title="Choice Report"
            tableHeaders={tableHeaders}
            defaultStartDate={new Date("2025-08-04T00:00:00")}
            defaultEndDate={new Date("2025-08-04T00:00:00")}
            renderRowCells={renderReportRowCells}
            data={tableData}
          />
        </div>
      </main>
    </div>
  )
}